
import Vue from 'vue'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'

import ResetPassword from './ResetPassword.vue'
import SetPassword from './SetPassword.vue'
import UnlockAccount from './UnlockAccount.vue'
import ChangeRole from './ChangeRole.vue'
import Subscriptions from './Subscriptions.vue'
import VerifyEmail from './VerifyEmail.vue'
import LoginAsUser from './LoginAsUser.vue'
import History from './History.vue'
import Delete from './Delete.vue'
import Session from './Session.vue'
import CopyPlans from './CopyPlans.vue'

export default Vue.extend({
   name: 'PillStack',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         selectedTab: 'Login As User',
      }
   },
   computed: {
      tabs(): string[] {
         if (this.userIsiUgoAdmin) {
            return [
               'Login As User',
               'Subscriptions',
               'Change Role',
               'Reset Password',
               'Set Password',
               'Unlock Account',
               'Verify Email',
               'History',
               'Delete',
               'Session',
               'Copy Plans',
            ]
         } else {
            return ['Reset Password']
         }
      },

      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
      currentTabComponent(): any {
         return this.selectedTab.replace(/ /g, '')
      },
   },
   mounted() {
      if (!this.userIsiUgoAdmin) {
         this.selectedTab = 'Reset Password'
      }
   },
   methods: {
      selectTab(name: string) {
         this.selectedTab = name
      },
   },
   components: {
      ResetPassword,
      SetPassword,
      UnlockAccount,
      ChangeRole,
      Subscriptions,
      VerifyEmail,
      LoginAsUser,
      History,
      Delete,
      Session,
      CopyPlans,
   },
})
